import { WebBaseSelectionForm } from './WebBaseSelectionForm.js';
import { df } from '../df.js';

/*
Class:
    df.WebSelectionForm
Extends:
    df.WebBaseSelectionForm

Implementation of the web suggestion form that is capable of showing a list of suggestions while 
typing. These suggestions can come from a variety of sources which is mainly determined on the 
server.

Revision:
    2020/09/25  (HW, DAW)
        Initial version.
*/
export class WebSelectionForm extends WebBaseSelectionForm {
    constructor(sName, oParent) {
        super(sName, oParent);

        this.event("OnSelect", df.cCallModeDefault, "privateOnSelect");
    }

    supportsPopupSearch() {
        return true;
    }

    /*
     Selects the item by sending a call to the server with the selected suggestion details.
     */
    suggestSelect (){
        if (this._oSelectedSuggestion && !this._oSelectedSuggestion.bServer) {
            let tRow = this.findSuggestionByRowId(this.suggestionRowId(this._oSelectedSuggestion));
            if (tRow) {
                this.set_psValue(tRow.aValues[0]);
                this.serverAction("SelectSuggestion", [], [tRow], null, null);
                this.suggestHide();
                this.focusMainControl();
                return;
            }
        }
        super.suggestSelect();
    }
};
